define('modules/editor/behaviours/apply_css_properties',['require','exports','module','underscore'],function(require, exports, module) {
  "use strict";

  var _ = require("underscore");

  module.exports = {
    applyStyles: function($el) {
      $el.css(_.foldl(this.properties, function(acc, prop) {
        var units = (this.units && this.units[prop]) || "px";
        acc[prop] = this.get(prop) + units;
        return acc;
      }, {}, this));
    }
  };

});

